import setMultipleBaseColors from 'src/js/modules/website-design/helpers/set-multiple-base-colors';

const setBaseColor = ({ colorKey, color, colorPalette }) => {
  const colorsToUpdate = { [colorKey]: color };

  return setMultipleBaseColors({ colorsToUpdate, colorPalette });
};

export default setBaseColor;
